import { useId } from 'react';
import IconCheck from '~/vendor/cxy/icons/icons/Check';
import clsx from 'clsx';

import styles from './styles/List.module.scss';

const iconSize = { s: 'xsm', m: 'sm' } as const;

export type ListProps = {
  classNames?: {
    checkIcon?: string;
    iconWrapper?: string;
    listItem?: string;
    listItemText?: string;
    wrapper?: string;
  };
  direction?: 'column' | 'row';
  items: string[];
  size?: 's' | 'm';
};

const List = ({ classNames, direction, items, size = 'm', ...props }: ListProps) => {
  const listId = useId();
  const style = direction ? { flexDirection: direction } : {};

  return (
    <ul
      className={clsx(styles.list, styles[`size--${size}`], classNames?.wrapper)}
      data-cxy-name="list"
      style={style}
      {...props}
    >
      {items.map((item, index) => (
        <li className={clsx(styles.listItem, classNames?.listItem)} key={`list-${listId}-item-${index}`}>
          <span className={clsx(styles.iconWrapper, classNames?.iconWrapper)}>
            <IconCheck className={clsx(styles.check, classNames?.checkIcon)} color="blue" size={iconSize[size]} />
          </span>
          <span className={clsx(styles.listItemText, classNames?.listItemText)}>{item}</span>
        </li>
      ))}
    </ul>
  );
};

export { List };
